import {AOperation} from "../models/operations/AOperation";
import {EOperationType} from "../models/utils/EOperationType";
import {InstallationElement} from "../models/operations/InstallationElement";
import {Geolocate} from "../models/operations/Geolocate";
import {UninstallElement} from "../models/operations/UninstallElement";
import {ReplaceElement} from "../models/operations/ReplaceElement";
import UninstallEquipment from "../models/operations/UninstallEquipment";
import {InstallationEquipment} from "../models/operations/InstallationEquipment";
import OperationType from "../components/steps/validation/items/OperationType";
import OperationDate from "../components/steps/validation/items/OperationDate";
import Localisation from "../components/steps/validation/items/Localisation";
import Commentary from "../components/steps/validation/items/Commentary";
import EquipmentId from "../components/steps/validation/items/EquipmentId";
import NewElement from "../components/steps/validation/items/NewElement";
import OldElement from "../components/steps/validation/items/OldElement";
import EquipmentType from "../components/steps/validation/items/EquipmentType";
import Element from "../components/steps/validation/items/Element";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 25/05/2022
 * @last_update 25/05/2022
 **/
class ValidationItemService  {

    public generatesValidationItemsAccordingToOperation(operation: AOperation): JSX.Element[] {
        let validationItems: JSX.Element[] = [];
        const operationType = operation.type;
        validationItems.push(<OperationType operationType={operationType}/>);
        validationItems.push(<OperationDate date={operation.date}/>);
        validationItems.push(<Localisation localisation={operation.geolocation}/>);
        switch (operationType) {
            case EOperationType.InstallationElement:
                validationItems = validationItems.concat(this.generatesValidationItemsForInstallationElement(operation as InstallationElement));
                break;
            case EOperationType.Geolocate:
                validationItems = validationItems.concat(this.generatesValidationItemsForGeolocate(operation as Geolocate));
                break;
            case EOperationType.InstallationEquipment:
                validationItems = validationItems.concat(this.generatesValidationItemsForInstallationEquipment(operation as InstallationEquipment));
                break;
            case EOperationType.UninstallationElement:
                validationItems = validationItems.concat(this.generatesValidationItemsForUninstallationElement(operation as UninstallElement));
                break;
            case EOperationType.ReplacementElement:
                validationItems = validationItems.concat(this.generatesValidationItemsForReplacementElement(operation as ReplaceElement));
                break;
            case EOperationType.UninstallationEquipment:
                validationItems = validationItems.concat(this.generatesValidationItemsForUninstallationEquipment(operation as UninstallEquipment));
                break;
            default:
                // Nothing to do
                break;
        }
        validationItems.push(<Commentary comment={operation.commentary}/>);
        return validationItems;
    }

    private generatesValidationItemsForInstallationElement(operation: InstallationElement): JSX.Element[] {
        let validationItems: JSX.Element[] = [];
        validationItems.push(<EquipmentId equipmentId={operation.equipmentId}/>);
        validationItems.push(<NewElement element={operation.newElement!}/>);
        return validationItems;
    }

    private generatesValidationItemsForGeolocate(operation: Geolocate): JSX.Element[] {
        let validationItems: JSX.Element[] = [];
        validationItems.push(<EquipmentId equipmentId={operation.equipmentId}/>);
        return validationItems;
    }

    private generatesValidationItemsForUninstallationElement(operation: UninstallElement): JSX.Element[] {
        let validationItems: JSX.Element[] = [];
        validationItems.push(<OldElement element={operation.oldElement!}/>);
        return validationItems;
    }

    private generatesValidationItemsForReplacementElement(operation: ReplaceElement): JSX.Element[] {
        let validationItems: JSX.Element[] = [];
        validationItems.push(<OldElement element={operation.oldElement!}/>);
        validationItems.push(<NewElement element={operation.newElement!}/>);
        return validationItems;
    }

    private generatesValidationItemsForUninstallationEquipment(operation: UninstallEquipment): JSX.Element[] {
        let validationItems: JSX.Element[] = [];
        validationItems.push(<EquipmentId equipmentId={operation.equipmentId}/>);
        return validationItems;
    }

    private generatesValidationItemsForInstallationEquipment(operation: InstallationEquipment): JSX.Element[] {
        let validationItems: JSX.Element[] = [];
        const equipment = operation.equipment;
        if(equipment) {
            validationItems.push(<EquipmentType equipmentType={equipment.type}/>);
            for(let i = 0; i < equipment.elements.length; i++) {
                validationItems.push(<Element element={equipment.elements[i]}/>);
            }
        }
        return validationItems;
    }
}

export default new ValidationItemService();
